import { registerImages, Source } from '@bonanza-social/moonlight';
import images from './images';

declare global {
  interface RegisteredImages {
    account: Record<keyof typeof images, Source>;
  }
}

registerImages('account', images);
